import React from 'react'
import { Label } from '~/components/ui'
import { cn } from '~/utils'

export type FormFieldContainerProps = {
  label?: string
  id?: string
  required?: boolean
  description?: string
  className?: string
  children?: React.ReactNode
}

export default function FormFieldContainer(props: FormFieldContainerProps) {
  const {
    label,
    id,
    required = false,
    description,
    className,
    children,
  } = props

  return (
    <div className={className}>
      {label && (
        <Label
          htmlFor={id}
          className={cn('block truncate', description ? 'mb-1' : 'mb-3')}>
          {label}
          {required && <span className="text-red-600">*</span>}
        </Label>
      )}
      {description && (
        <p className="mb-2 text-sm text-muted-foreground">{description}</p>
      )}
      {children}
    </div>
  )
}
